@if (selectionValues) {
    <kui-select [options]="selectionValues" (change)="changeSelection($event)"></kui-select>
}
@if (values) {
    <key-form-builder [form]="form" class="d-block mt-3" [values]="values" autoTranslatePrefix="ANALYTICS.SETTINGS" (onChange)="changeFormSetting($event)"></key-form-builder>
}
